<template>
  <div style="position: relative;">
    <div v-show="disabled" class="dim"/>
    <div v-show="disabled" class="text">
      <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          version="1.1"
          id="Layer_1"
          x="0px"
          y="0px"
          width="72px"
          height="72px"
          viewBox="0 0 72 72"
          enable-background="new 0 0 72 72"
          xml:space="preserve"
          style="
          display: block;margin: auto;
          filter: invert(100%);
          "
      >
        <image
            id="image0" width="72" height="72" x="0" y="0"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAJ1BMVEVHcEwAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD///9+MwwUAAAAC3RSTlMAEKDvIELC32SBMCOy6OMAAAAB YktHRAyBs1FjAAAAB3RJTUUH5gYYBjsTqqUKuwAAAahJREFUSMftlLFOwzAQhk1lUgeWSLxAJcTU BRAbS7YOXRArCwsSUpcgsWXpxMLCTBfEwMKCoLSgezl8ztmJic9eYOtJaaP0i/37/NVCbOr/amv/ uEhCA4BREpoCfCahGcAqxWyDrrMENEToMgHdI5QKVSOUCKXA1DwVaa0Hu0lF+tLXd4yRepQqA/go IlCOebBVDxFoYlamm34UgcamRxfRUBKMAhiqZCGtCZTN/o1YSGvyTrMuY5GWBLM7I+00eUSXrImk PT/ldWmXvuB10XtyK8T5oxB7bChltkOhKHwo1MR8ViZUFYRQEyF2Ad7sfThSZSEctWAizS3E6TIx kQjidFk0MQgK6yKpywSFHR5QawgKh7KaDKlDOtRJD7KaKPprvtJLXiRn4/OBm74MRPKeyYAu097o AV1mPa37unRWfHfdfPd1wQ0t7W9mdQGH25NE44dMqNpJRh1vQq27jGpPt8xNon4decP2JVmvynb4 7pHXtXXnyd75usg66L2vSx4+cH1duAPCc3gMbLlQkmfaUCoCuax5DLLJcSvZsp0VLzxzJTb1t/UD Zcd48b/bUJEAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMDYtMjRUMDM6NTk6MTkrMDM6MDDEEnnE AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIyLTA2LTI0VDAzOjU5OjE5KzAzOjAwtU/BeAAAAABJRU5E rkJggg=="
        />
      </svg>
      Coming Soon
    </div>
    <div class="rehabListSection">
      <RehabList
          v-on:showSelectedRows="showSelectedRows"
          :refinedExerciseListProps="refinedExerciseList"
          :selectedRowsProps="selectedRows"
          :patientInfoProps="patientInfoProps"
          @appendExerciseList="appendExerciseList"
          @updateExerciseList="updateExerciseList"
      />
      <RehabDetails
          :refinedExerciseListProps="refinedExerciseList"
          :selectedRowsProps="selectedRows"
          :detailsAndRecordComponentIdxProps="detailsAndRecordComponentIdx"
          :patientInfoProps="patientInfoProps"
          @updateExerciseStatus="updateExerciseStatus"
          @deleteExerciseGuide="deleteExerciseGuide"
      />
    </div>
    <div class="rehabilitationRow row">
      <RehabRecord
          :refinedExerciseListProps="refinedExerciseList"
          :selectedRowsProps="selectedRows"
          :detailsAndRecordComponentIdxProps="detailsAndRecordComponentIdx"
      />
      <AddAndEditExerciseModal
          :disabled="disabled"
          @appendExerciseList="appendExerciseList"
          @updateExerciseList="updateExerciseList"
      />
<!--      fixme: 혹시 부여운동 또 막을까바 주석처리-->
<!--      <AddAndEditExerciseModal-->
<!--          :live="live"-->
<!--          @appendExerciseList="appendExerciseList"-->
<!--          @updateExerciseList="updateExerciseList"-->
<!--      />-->
    </div>
  </div>
</template>
<script>
import RehabDetails from "./details"
import RehabRecord from "./record"
import RehabList from "./list"
import AddAndEditExerciseModal from '@/components/modal/addAndEditExercise'
import _API from '../../../../api';
import * as ENUM from "@/enum/lib";
import {
  mapGetters,
} from 'vuex';

export default {
  props: [
    'patientInfoProps'
  ],
  components: {
    RehabList,
    RehabDetails,
    RehabRecord,
    AddAndEditExerciseModal,
  },
  data() {
    const disabledCheck = this.getCheckTimeZoneProduct();

    return {
      exerciseList: [],   // 원본 데이터
      refinedExerciseList: [],    // status 가 계산된 데이터
      selectedRows: -1,
      selectedSeqExercise: '',
      detailsAndRecordComponentIdx: 0,
      disabled: disabledCheck
    }
  },
  methods: {
    ...mapGetters([
        'getAuth',
        'getCheckTimeZoneProduct',
    ]),
    getDetailExerciseListBySeqMedicalRelationBySingleRange() {
      // due date가 오늘이거나 오늘 이상인 것만 불러온다.
      const seqMedicalRelation = this.patientInfoProps?.patientInfo?.seqMedicalRelation
      const datetime = this.moment().format('YYYY-MM-DDT00:00:00Z');
      const data = {seqMedicalRelation, datetime};

      if (seqMedicalRelation !== undefined)
        _API.EXERCISE_LIST.getDetailExerciseListBySeqMedicalRelationBySingleRange(data)
            .then(res => {
              if (res.data.isSuccess) {
                // TODO : lodash cloneDeep
                this.exerciseList = JSON.parse(JSON.stringify(res.data.exerciseList));
                const copiedExerciseList = JSON.parse(JSON.stringify(this.exerciseList));
                this.refineExerciseList(copiedExerciseList).then(listResult => {
                  this.refinedExerciseList = listResult;
                  this.refinedExerciseList.sortByOrder('seqExercise', true);
                });
              }
            })
            .catch(e => {
              console.error(e);
            });
    },
    showSelectedRows(seqExercise, i) {
      this.selectedSeqExercise = seqExercise;
      this.selectedRows = i;
      this.detailsAndRecordComponentIdx = 1;
    },
    /**
     * 새롭게 운동을 추가했을경우 실행되는 함수, 임의로 refinedExerciseList 를 하나 가공해서 리스트에 추가함.
     * @param data
     * @param seqExercise
     */
    appendExerciseList(data, seqExercise) {
      if (this.disabled)
        return;

      const appendData = [{
        seqExercise: seqExercise,
        seqExerciseGuide: 0,
        seqMedicalRelation: data.seqMedicalRelation,
        exerciseEndDatetime: data.exerciseEndDatetime,
        exerciseSet: data.exerciseSet,
        exerciseStatus: 0,
        createDatetime: 0,
        exerciseCourseLength: 0,
        patientName: this.patientInfoProps.patientName,
        seqDeviceType: data.seqDeviceType,
        seqManager: this.getAuth().seqManager,
        seqPatient: this.patientInfoProps.seqPatient,
        exerciseGuide: {
          exerciseGuideTitle: data.exerciseGuide.exerciseGuideTitle,
          exerciseGuideContext: data.exerciseGuide.exerciseGuideContext,
          exerciseGuideEvent: data.exerciseGuide.exerciseGuideEvent,
          exerciseGuideMode: data.exerciseGuide.exerciseGuideMode, // 0,1,2,3
          exerciseGuidePosition: data.exerciseGuide.exerciseGuidePosition, // 1,2,3,4
          exerciseGuideDirection: data.exerciseGuide.exerciseGuideDirection, //  1,2
          exerciseGuideCount: data.exerciseGuide.exerciseGuideCount,
          exerciseGuideTime: data.exerciseGuide.exerciseGuideTime,
          exerciseGuideSpeed: data.exerciseGuide.exerciseGuideSpeed,
          exerciseGuideFlexion: data.exerciseGuide.exerciseGuideFlexion,
          exerciseGuideExtension: data.exerciseGuide.exerciseGuideExtension,
          exerciseGuideUseAbsRom: data.exerciseGuide.exerciseGuideUseAbsRom,
          exerciseGuideHandGripType: data.exerciseGuide.exerciseGuideHandGripType,
          exerciseGuideDeviceLoh: data.exerciseGuide.exerciseGuideDeviceLoh,

          exerciseGuideMinRom: data.exerciseGuide.exerciseGuideMinRom,
          exerciseGuideMaxRom: data.exerciseGuide.exerciseGuideMaxRom,
          exerciseGuideMuscleStiffSensitive: data.exerciseGuide.exerciseGuideMuscleStiffSensitive,
          exerciseGuideFlexionLimitTime: data.exerciseGuide.exerciseGuideFlexionLimitTime,
          exerciseGuideExtensionLimitTime: data.exerciseGuide.exerciseGuideExtensionLimitTime,
          exerciseGuideFlexionDelayTime: data.exerciseGuide.exerciseGuideFlexionDelayTime,
          exerciseGuideExtensionDelayTime: data.exerciseGuide.exerciseGuideExtensionDelayTime,
          exerciseGuideKneeMinRom: data.exerciseGuide.exerciseGuideKneeMinRom,
          exerciseGuideKneeMaxRom: data.exerciseGuide.exerciseGuideKneeMaxRom,
          exerciseGuideAnkleMinRom: data.exerciseGuide.exerciseGuideAnkleMinRom,
          exerciseGuideAnkleMaxRom: data.exerciseGuide.exerciseGuideAnkleMaxRom,
        },
        recordList: []
      }];
      this.exerciseList.push(appendData);
      this.refineExerciseList(appendData)
          .then(resultData => {
            this.refinedExerciseList.push(resultData[0]);
            this.refinedExerciseList.sortByOrder('seqExercise', true);
            this.detailsAndRecordComponentIdx = 1;
            this.selectedSeqExercise = seqExercise;
            this.selectedRows = 0;
          })
          .catch(err => {
            throw err
          })
    },
    refineExerciseList(copiedExerciseList) {
      // DB 에서 가져온 exerciseStatus 는 0,1,2 총 세개의 값이다.
      // 1 = 의사가 버튼을 눌러 중지시킨 경우
      // 2 = 의사가 버튼을 눌러 수행완료를 시킨 경우
      // 0 = 그 이외의 모든 경우
      // 이 메서드는 exerciseStatus 와 날짜, recordList(수행여부)를 기준으로 다시 status 값을 0,1,2,3,4,5로 총 6개로 재정의한다. 다음과 같다.
      //  0 = waiting / 1 = terminated / 2 = accomplished(수동) / 3 = accomplished(자동)/ 4 = on Progress / 5 = canceled
      return new Promise(resolve => {
        for (let i = 0; copiedExerciseList.length > i; i++) {
          if (copiedExerciseList[i].exerciseStatus === 0) {
            // 마감일이 남아 있는 경우
            if (this.moment(copiedExerciseList[i].exerciseEndDatetime).diff(this.moment(), 'days') >= 0) {
              if (copiedExerciseList[i].exerciseCourseLength >= copiedExerciseList[i].exerciseSet) {
                // 운동을 부여받은 세트 이상으로 수행한 경우
                copiedExerciseList[i].exerciseStatus = ENUM.EXERCISE_STATUS.ACCOMPLISHED_AUTO;
              } else if (copiedExerciseList[i].exerciseCourseLength >= 1) {
                // 운동을 1개 이상 수행한 경우
                copiedExerciseList[i].exerciseStatus = ENUM.EXERCISE_STATUS.ON_PROGRESS;
              }
              continue
            }
            // 마감일이 남아 있지 않은 경우
            if (copiedExerciseList[i].exerciseCourseLength >= 1) {
              // 운동을 1개 이상 수행한 경우
              copiedExerciseList[i].exerciseStatus = ENUM.EXERCISE_STATUS.ACCOMPLISHED_AUTO;
            } else {
              // 운동을 수행하지 않은 경우
              copiedExerciseList[i].exerciseStatus = ENUM.EXERCISE_STATUS.CANCELED;
            }
          }
        }
        resolve(copiedExerciseList);
      });
    },
    updateExerciseStatus(status) {
      if (this.disabled)
        return;

      const data = {
        seqExercise: this.selectedSeqExercise,
        exerciseStatus: status
      }

      return new Promise((_resolve, reject) => {
        _API.EXERCISE_LIST.updateExerciseStatusBySeqExercise(data)
            .then(res => {
              if (res.data.isSuccess === true && res.status === 200) {
                for (let i = 0; this.refinedExerciseList.length > i; i++) {
                  if (this.refinedExerciseList[i].seqExercise === data.seqExercise) {
                    this.refinedExerciseList[i].exerciseStatus = data.exerciseStatus;
                  }
                }
              } else if (res.data.failedCode === 1) {
                reject(`[updateExerciseStatusBySeqExercise] 예기치 못한 에러 발생`)
              }
            })
            .catch(e => {
              reject(e);
            })
      })
    },
    updateExerciseList(data) {
      if (this.disabled)
        return;

      const item = this.refinedExerciseList.find(it => it.seqExercise === data.seqExercise)
      item.seqDeviceType = data.seqDeviceType;
      item.exerciseEndDatetime = data.exerciseEndDatetime;
      item.exerciseSet = data.exerciseSet;
      for (const [key] of Object.entries(item.exerciseGuide)) {
        item.exerciseGuide[key] = data.exerciseGuide[key];
      }
    },
    deleteExerciseGuide() {
      if (this.disabled)
        return;

      return new Promise((_resolve, reject) => {
        _API.EXERCISE_LIST.deleteExerciseGuideBySeqExercise(this.selectedSeqExercise)
            .then(res => {
              if (res.data.isSuccess === true && res.status === 200) {
                this.$modal.show('common-alert-modal', {
                  messageType: 'short',
                  message: 'alert.delete_completed'
                });
                this.refinedExerciseList.splice(this.selectedRows, 1);
                this.selectedRows = -1;
                this.detailsAndRecordComponentIdx = 0;
              }
            })
            .catch(e => {
              reject(`[deleteExerciseGuideBySeqExercise] ${e}`);
            });
      });
    },
  },
  watch: {
    patientInfoProps: {
      deep: true,
      handler() {
        this.getDetailExerciseListBySeqMedicalRelationBySingleRange();
      }
    }
  },
  created() {
    this.getDetailExerciseListBySeqMedicalRelationBySingleRange();
  }
}
</script>
<style lang="scss">
  .rehabListSection {
    min-height: 270px;
    display: flex;
    .section {
      height: 380px;
    }

    div:nth-child(1) {
      flex: 3;
    }

    div:nth-child(2) {
      flex: 5;
    }

    .table-header {
      .item-value:nth-child(1) {
        flex-grow: 5 !important;
      }
    }

    .item-parent {
      margin: 0;
    }

    .table-body {
      .item-value:nth-child(1) {
        flex-grow: 5 !important;
      }
    }
  }

  .col_w_6 {
    width: calc(50% - 22px);
    float: left;
    min-height: 400px;
  }

  .reh_con_scroll {
    overflow-y: auto;
  }

  .section_wrap {
    margin: 30px 35px;
    position: relative;

    .section_title {
      .con_date {
        float: right;
        font-size: 14px;
        color: #c8c8c8;
        font-weight: normal;
      }

      .con_add a {
        float: right;
        font-size: 13px;
        color: var(--blue70);
        font-weight: normal;

        img {
          margin-right: 5px;
        }
      }

      .right_btn a {
        float: right;
        font-size: 14px;
        color: #c8c8c8;
        font-weight: normal;
      }
    }
  }

  .rehabilitationRow {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }

  .dim{
    background-color: #3b3a39;
    position: absolute;
    z-index: 100;
    width: 100%;
    height: 100%;
    border-radius: 5px;
    opacity: 0.5;
    display: flex;
  }

  .text{
    position: absolute;
    z-index: 101;
    font-size: 30px;
    color: #FFFFFF;
    left: calc(50% - 130px);
    top: calc(50% - 50px);
  }

  .dim{
    background-color: #3b3a39;
    position: absolute;
    z-index: 100;
    width: 100%;
    height: 100%;
    border-radius: 5px;
    opacity: 0.5;
    display: flex;
  }

  .text{
    position: absolute;
    z-index: 101;
    font-size: 30px;
    color: #FFFFFF;
    left: calc(50% - 130px);
    top: calc(50% - 50px);
  }
</style>